import { render, staticRenderFns } from "./SettingsIndexesForms.vue?vue&type=template&id=e328c0e8&"
import script from "./SettingsIndexesForms.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports